import { TranslateHtml } from '@change-corgi/core/react/i18n';
import { Box } from '@change-corgi/design-system-legacy/layout';
import { Text } from '@change-corgi/design-system-legacy/typography';

export function UpdateHelpText() {
	return (
		<Box
			px={16}
			py={16}
			mb={16}
			sx={{
				backgroundColor: 'primary-greyBackground',
				borderRadius: 'standard',
				width: '100%',
			}}
		>
			<Text as="div" size="small">
				<TranslateHtml value="fe.pages.petition_update_composer.disclaimer" />
			</Text>
		</Box>
	);
}
